export const PATH_REGEX_PATTERN = /\/(?<locale>(?<lang>[a-z]{2})(?:(?<separator>[-_])(?<country>[a-z]{2,}\d*|\d+))?)\//i;
//# sourceMappingURL=constants.js.map